/** Public, non-authoritative Registry V2 wire identities shared by indexer clients. */
export const REGISTRY_V2_PROTOCOL = "registry-v2" as const;
export const REGISTRY_V2_CHAIN_ID = 8453 as const;

export type RegistryV2DeploymentReference = Readonly<{
  schemaVersion: 1;
  protocol: typeof REGISTRY_V2_PROTOCOL;
  chainId: typeof REGISTRY_V2_CHAIN_ID;
  registryAddress: `0x${string}`;
  deploymentBlockNumber: string;
  deploymentBlockHash: `0x${string}`;
  deploymentTransactionHash: `0x${string}`;
  registryRuntimeCodeHash: `0x${string}`;
  sourceCommitment: string;
}>;

export type RegistryV2EventIdentity = Readonly<{
  blockNumber: bigint;
  blockHash: `0x${string}`;
  transactionHash: `0x${string}`;
  transactionIndex: number;
  logIndex: number;
}>;

export function registryV2EventId(registryAddress: string, identity: RegistryV2EventIdentity): string {
  if (!/^0x[0-9a-f]{40}$/.test(registryAddress) || /^0x0{40}$/.test(registryAddress)) throw new TypeError("invalid V2 registry address");
  if (identity.blockNumber < 0n || !/^0x[0-9a-f]{64}$/.test(identity.blockHash) || !/^0x[0-9a-f]{64}$/.test(identity.transactionHash)) throw new TypeError("invalid V2 event hash identity");
  if (!Number.isSafeInteger(identity.transactionIndex) || identity.transactionIndex < 0 || !Number.isSafeInteger(identity.logIndex) || identity.logIndex < 0) throw new TypeError("invalid V2 event index");
  return `v2:${REGISTRY_V2_CHAIN_ID}:${registryAddress}:${identity.blockHash}:${identity.transactionHash}:${identity.logIndex}`;
}
